/**
 * Fraud Alert Service - Service for fraud alert operations
 * Works with both web and mobile platforms
 */
export { FRAUD_ALERT_TYPE_LABELS, FRAUD_ALERT_SEVERITY_LABELS, FRAUD_ALERT_STATUS_LABELS, FRAUD_ALERT_SEVERITY_COLORS, FRAUD_ALERT_STATUS_COLORS, } from '../types/fraudAlert';
/**
 * Service for managing fraud alerts
 */
export class FraudAlertService {
    constructor(client) {
        this.client = client;
    }
    /**
     * Get singleton instance for a specific API client
     */
    static getInstance(client) {
        if (!this.instances.has(client)) {
            this.instances.set(client, new FraudAlertService(client));
        }
        return this.instances.get(client);
    }
    /**
     * List fraud alerts for an account
     */
    async listByAccount(accountId, params) {
        return this.client.get(`/accounts/${accountId}/fraud-alerts`, params);
    }
    /**
     * List fraud alerts for a location
     */
    async listByLocation(locationId, params) {
        return this.client.get(`/locations/${locationId}/fraud-alerts`, params);
    }
    /**
     * List fraud alerts for a specific user
     */
    async listByUser(userId, params) {
        return this.client.get(`/users/${userId}/fraud-alerts`, params);
    }
    /**
     * List fraud alerts for a specific work session
     */
    async listBySession(sessionId) {
        return this.client.get(`/sessions/${sessionId}/fraud-alerts`);
    }
    /**
     * Get fraud alert statistics for an account
     */
    async getStats(accountId, params) {
        return this.client.get(`/accounts/${accountId}/fraud-alerts/stats`, params);
    }
    /**
     * Review a fraud alert
     */
    async reviewAlert(alertId, request) {
        return this.client.post(`/fraud-alerts/${alertId}/review`, request);
    }
    /**
     * Review multiple fraud alerts at once with a single disposition.
     */
    async bulkReviewAlerts(request) {
        return this.client.post(`/fraud-alerts/bulk-review`, request);
    }
}
FraudAlertService.instances = new Map();
